import { META_FALLBACK_IMAGE } from './../constants';
export const centreAddress = centre => ({
  '@type': 'PostalAddress',
  addressLocality: centre.suburb,
  addressRegion: centre.state,
  postalCode: centre.postcode,
  streetAddress: centre.physicalAddress
});

const tradingHoursToStructuredData = hours => hours.map(tradingHoursOfADay => ({
  '@type': 'OpeningHoursSpecification',
  opens: tradingHoursOfADay.openingTime,
  closes: tradingHoursOfADay.closingTime,
  validFrom: tradingHoursOfADay.date,
  validThrough: tradingHoursOfADay.date
}));

export const getCentreStructuredData = _ref => {
  let {
    url,
    centre,
    imageUrl,
    name,
    description,
    tradingHours
  } = _ref;

  if (!url) {
    return null;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': "".concat(url, "#webpage"),
    name,
    url,
    description,
    mainEntity: {
      openingHoursSpecification: tradingHours && tradingHoursToStructuredData(tradingHours),
      '@type': 'ShoppingCenter',
      name,
      image: imageUrl || META_FALLBACK_IMAGE,
      description,
      url,
      address: centreAddress(centre),
      sameAs: [centre.facebook, centre.instagram].filter(elem => elem)
    }
  };
};